import {
	alwaysRefetchApiQueryOptions,
	capitalizeFirstLetter,
	handleApiError,
	type IManageUSDOptions,
	type IUseCryptoSettingsApi,
	showToast,
} from 'BreetHelpers';
import { selectFiatMeta, useAppSelector, useGetUserPreferenceQuery, useUpdatePreferenceMutation } from 'BreetRedux';
import { useCallback } from 'react';

export const useCryptoSettingsApi = (): IUseCryptoSettingsApi => {
	const { data: userPreferenceData, isLoading, isFetching } = useGetUserPreferenceQuery(undefined, alwaysRefetchApiQueryOptions);

	const fiatMeta = useAppSelector(selectFiatMeta);
	const currentReceiveCurrency = userPreferenceData?.data?.receiveCurrency ?? fiatMeta.currencyLower;

	const [updatePreference, { isLoading: isUpdating }] = useUpdatePreferenceMutation();

	const manageUSD = useCallback(
		({ receiveCurrency, onSuccess }: IManageUSDOptions) => {
			const isFiat = receiveCurrency === 'ngn' || receiveCurrency === 'ghs';
			updatePreference({
				receiveCurrency,
			})
				.unwrap()
				.then(() => {
					showToast(
						'success',
						`Crypto will now be received in ${isFiat ? capitalizeFirstLetter(fiatMeta.currencyShort) : receiveCurrency.toUpperCase()} Wallet`
					);
					onSuccess?.();
				})
				.catch(handleApiError);
		},
		[fiatMeta.currencyShort, updatePreference]
	);

	return {
		manageUSD,
		currentReceiveCurrency,
		isLoading,
		isFetching,
		fiatMeta,
		isUpdating,
	};
};
